import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M78.252 32.555c-1.6 2.3-3.5 4.3-5.8 6v1.5c0 3.1-.5 6.3-1.4 9.3-.9 3.2-2.3 6.2-4.1 8.9-1.8 2.8-4.1 5.4-6.6 7.5-2.7 2.3-5.9 4.1-9.2 5.2-3.7 1.3-7.6 2-11.6 2-6.3 0-12.5-1.8-17.8-5.2.9.1 1.9.1 2.8.1 5.2.1 10.3-1.7 14.4-4.9-4.9-.1-9.3-3.3-10.8-8 .7.1 1.5.2 2.2.2 1 0 2.1-.1 3-.4-2.6-.5-5-1.9-6.6-4-1.7-2.1-2.7-4.7-2.6-7.4v-.1c1.6.9 3.4 1.4 5.2 1.5-1.6-1-2.9-2.5-3.8-4.1-1.9-3.6-1.9-7.9.2-11.4 2.9 3.6 6.5 6.5 10.5 8.5 4.1 2.1 8.7 3.3 13.3 3.6-.2-.9-.3-1.8-.3-2.7 0-6.4 5.2-11.6 11.6-11.6 3.2 0 6.2 1.3 8.4 3.7 2.6-.5 5.1-1.4 7.3-2.8-.8 2.7-2.7 5-5.1 6.4 2.4-.3 4.7-.9 6.8-1.8z" />
  </svg>
);
